export enum ConversationInitiatorType {
  Buy = 'buy',
  Bundle = 'bundle',
  Message = 'message',
  AskSeller = 'ask_seller',
  BuyerOffer = 'buyer_offer',
  MarkAsSold = 'mark_as_sold',
  Reservation = 'reservation',
  SystemMessage = 'system_message',
  BuyerEntersOfferForm = 'buyer_enters_offer_form',
  SellerEntersNotification = 'seller_enters_notification',
}

export enum ConversationMessageType {
  ActionMessage = 'action_message',
  StatusMessage = 'status_message',
  Message = 'message',
  PortalMessage = 'portal_message',
  OfferMessage = 'offer_message',
  OfferRequestMessage = 'offer_request_message',
  ReportSuggestion = 'report_suggestion',
  AutoReplyFeedbackRequestMessage = 'auto_reply_feedback_request_message',
  ChatbotFeedbackRequestMessage = 'chatbot_feedback_request_message',
  ConversationalChatbotFeedbackRequestMessage = 'conversational_chatbot_feedback_request_message',
}

export enum StatusStyle {
  Gray = 'gray_box',
  Green = 'green_box',
  Red = 'red_box',
  Clear = 'clear_box',
}

export enum StatusIcon {
  Sale = 'sale',
  Shipment = 'shipment',
  Completion = 'completion',
  Failure = 'failure',
}

export enum ConversationLinkActions {
  ShipmentTrackingLink = 'react-shipment-tracking-link',
  BuyerDetailsLink = 'buyer-details-link',
  OfflineVerificationInfoLink = 'react-offline-verification-info-link',
  DropOffPointMapLink = 'react-drop-off-point-map-link',
  ReactElectronicsVerificationInfoLink = 'react-electronics-verification-info-link',
  PickUpParcelLink = 'react-pickup-parcel-link',
}

export enum ComposerType {
  Reply = 'reply',
}

export enum ModeratedItemAvailabilityStatus {
  Visible = 0,
  Hidden = 1,
  Deleted = 2,
  Expired = 3,
}

export enum TransactionSide {
  Buyer = 'buyer',
  Seller = 'seller',
}

export enum TransactionStatus {
  DebitProcessed = 230,
  StatusNew = 1,
  StatusEstimated = 100,
  StatusDebitFailed = 220,
}

export enum ApplicableTransactionAction {
  Offer = 'offer',
  Buy = 'buy',
  RequestOffer = 'request_offer',
  Transfer = 'transfer',
  Reserve = 'reserve',
  WaitingForShipment = 'waiting_for_shipment',
  LeaveFeedback = 'feedback',
}

export enum AdditionalTransactionAction {
  MarkAsSold = 'mark_as_sold',
  MarkAsReceived = 'mark_as_received',
  CanMarkAsReceived = 'can_mark_as_received',
  Bundle = 'bundle',
  UsePayments = 'use_payments',
  DeleteConversation = 'delete_thread',
  Cancel = 'cancel',
  ConfirmShipmentInstructions = 'confirm_shipment_instructions',
  ExtendShippingDeadline = 'extend_shipping_deadline',
  ChangeDeliveryOption = 'change_delivery_option',
}

export enum SafetyFlag {
  EscrowWarning = 1,
}

export enum EscrowBannerTrackingType {
  Warning = 'non_escrow_warning_banner',
  Info = 'non_escrow_info_banner',
}

export enum ItemShippingDetailsDiscountType {
  All = 'all',
  Home = 'home',
  DropOff = 'drop_off',
}
